import React from 'react'
import academyEnrollBanner from "./../../../../../Images/Blog/Top_10_Reasons_to_ Enroll_in_ Salon_Academy/Banner.png"

const AcademyEnrollImg = () => {
  return (
    <div className="pediManicureImg">
      <img src={academyEnrollBanner} alt="academyEnrollBanner" loading='lazy'/>
    </div>
  )
}

export default AcademyEnrollImg
